import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { Plus } from "lucide-react";

const NoteDeFraisForm = lazy(() =>
  import("@/features/rh/notes-de-frais/components/NoteDeFraisForm").then((m) => ({
    default: m.default,
  })),
);

export const Route = createFileRoute("/_app/(dashboard)/frais/create")({
  loader: requirePermission(PERMISSIONS.RH.FRAIS?.VIEW || "rh.frais.view"),
  staticData: {
    title: "Nouvelle Note de Frais",
    icon: Plus,
    permission: PERMISSIONS.RH.FRAIS?.VIEW || "rh.frais.view",
    section: "App",
    showInTab: false,
  },
  component: () => <NoteDeFraisForm autoPersonne hidePersonne backTo="/frais/me" />,
});